import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { deleteCommission } from 'bundles/apex/deals/show/store/deal/actions';

import AddControl from 'components/add_control';
import Card from 'bundles/apex/card';
import EmptyState from 'bundles/backoffice/contacts/contact_empty_state';

import Broker from 'bundles/apex/deals/show/brokers/broker';
import Modal from './modal';
import UserIcon from 'components/user_icon';

export function InternalBrokers({ deal, forUser, restrictBrokerGrossVisibilityToSelf }) {
  const commissions = deal.commissions.filter(commission => !commission.outside);
  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  const controls = (
    <AddControl onClick={() => setShowModal(true)}>
      Add broker
    </AddControl>
  );

  let children;
  if (commissions.length == 0) {
    children = <EmptyState contactLabel="internal broker" forDeal />;
  } else {


    children = commissions.map((commission, i) => {
      const disableCommisionView = restrictBrokerGrossVisibilityToSelf &&
        !forUser.apexAdmin &&
        commission.broker.id !== forUser.id;
      return (
        <Broker
          commission={commission}
          deletable={commissions.length > 1}
          disableCommisionView={disableCommisionView}
          icon={<UserIcon size="xl" user={deal.brokers.find(broker => broker.id === commission.broker.id)} />}
          index={i}
          key={i}
        >
          <div>
            <div className="text-muted fs-small">
              {i === 0 ? 'Primary Broker' : 'Internal Broker'}
            </div>

            {commission.broker.name}
          </div>
        </Broker>
      );
    });
  }

  return <React.Fragment>
    <Card
      controls={controls}
      label="Internal Brokers"
      verticalBody
    >
      {children}
    </Card>

    <Modal
      forDeal
      show={showModal}
      onHide={closeModal}
    />
  </React.Fragment>;
}

InternalBrokers.propTypes = {
  deal: PropTypes.shape({
    brokers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
    commissions: PropTypes.arrayOf(PropTypes.shape({
      broker: PropTypes.shape({
        id: PropTypes.number.isRequired,
      }),
      outside: PropTypes.bool,
    })).isRequired,
  }).isRequired,
  deleteCommission: PropTypes.func,
  forUser: PropTypes.shape({
    apexAdmin: PropTypes.bool,
    id: PropTypes.number.isRequired,
  }).isRequired,
  restrictBrokerGrossVisibilityToSelf: PropTypes.bool,
};

const mapStateToProps = state => ({
  deal: state.deal,
  forUser: state.forUser,
  restrictBrokerGrossVisibilityToSelf: state.features.restrictBrokerGrossVisibilityToSelf,
});

const mapDispatchToProps = {
  deleteCommission
};

export default connect(mapStateToProps, mapDispatchToProps)(InternalBrokers);
